import React, { useEffect, useState } from "react";
import { useTunnelData } from "../TunnelContext";
import OAButton from "../components/OAButton";
import Choice from "../Choice";
import Breadcrumbs from "../components/Breadcrumbs";
import { ChevronLeft } from "lucide-react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from "react-i18next";
import PromoBanner from "../components/PromoBanner";
import Footer from "../components/Footer";
import MobileCarousel from "../components/MobileCarousel";
import pushEvent from "../pushEvent";
import { useConfig } from "../ConfigProvider";
import OACheckbox from "../components/OACheckbox";
import Countdown from "../components/Countdown";

export default function OfferSelect({ plans, errorMsg, errorMsgSet }) {
  const { tunnel, setTunnelOffer, setTunnelRegulars } = useTunnelData();
  const config = useConfig();
  const mql = window.matchMedia("(max-width: 600px)");
  const isMobile = mql.matches;
  const { splitPlans, code, currency } = useConfig();
  const [step, stepSet] = useState("SELECT_PLAN");
  const [split, splitSet] = useState("comptant");
  const [filtered, filteredSet] = useState(plans);

  useEffect(() => {
    if (!splitPlans) {
      filteredSet(plans);
      return;
    }
    filteredSet(
      plans.filter((p) => {
        if (split === "no_engagement") {
          return p.offer.name.toLowerCase().indexOf("sans engagement") !== -1;
        }
        if (split === "engagement") {
          return p.offer.name.toLowerCase().indexOf("avec engagement") !== -1;
        }
        if (split === "comptant") {
          return (
            p.offer.name.toLowerCase().indexOf("sans engagement") === -1 &&
            p.offer.name.toLowerCase().indexOf("avec engagement") === -1
          );
        }
        return true;
      })
    );
  }, [split, splitPlans]);

  const history = useHistory();

  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
    pushEvent({
      event: "funnel_step_2",
      step_name: "Abonnement",
      funnel_club: tunnel.club.name,
      funnel_club_status: "Ouvert",
    });
  }, []);

  const select = (offer) => {
    errorMsgSet(false);
    setTunnelOffer(offer);
    if (tunnel.products.regulars.length) {
      stepSet("SELECT_REGULARS");
    } else {
      history.push("/user");
    }
  };

  const switchRegulars = (regular) => {
    errorMsgSet(false);
    console.log("va te...");
    const r = Object.values(tunnel.regulars);
    const found = Object.values(tunnel.regulars).findIndex((f) => f.regular["@id"] === regular["@id"]);
    if (found >= 0) {
      r.splice(found, 1);
      setTunnelRegulars(r);
    } else {
      r.push(regular);
      setTunnelRegulars({
        ...tunnel.regulars,
        [regular.id.split("/")[3]]: {
          regular: regular,
          count: 1,
        },
      });
    }
  };

  if (step === "SELECT_REGULARS")
    return (
      <>
        <main className="w-full md:h-[calc(100vh-176px)] overflow-hidden bg-oaBackgroundColor bg-[url('/src/assets/picto.svg')] bg-no-repeat bg-contain bg-center bg-fixed md:bg-none flex  flex-col items-center md:px-20">
          <div className="w-full mt-10 md:mt-0">
            <Breadcrumbs />
          </div>
          <p
            onClick={() => stepSet("SELECT_PLAN")}
            className="absolute left-4 top-5 md:left-20 flex flex-row hover:text-oaRed transition-all duration-300"
          >
            <ChevronLeft className="mr-2" />
            {t("previous_step")}
          </p>

          <div className="md:grid md:grid-cols-2 overflow-scroll md:px-40">
            {tunnel.products.regulars.map((regular, i) => {
              const regulars = Object.values(tunnel.regulars).filter((e) => e.count > 0);
              const found = regulars ? regulars.findIndex((f) => f.regular["@id"] === regular["@id"]) : -1;
              const isSelected = found !== -1;
              return (
                <div
                  key={`${regular.name}-${i}`}
                  className=" border rounded-md bg-white m-4 cursor-pointer flex flex-col gap-3 justify-between"
                  onClick={(e) => {
                    e.preventDefault();
                    switchRegulars(regular);
                  }}
                >
                  <div>
                    <p className="text-oaRed text-center font-semibold text-xl pt-6 px-6">{regular.d.name}</p>
                    <p className="text-center mb-3 font-bold text-lg px-6">
                      {regular.d.price_1},{regular.d.price_2} {currency}
                    </p>
                    {regular.properties.extendedImage ? (
                      <img
                        src={`https://api.resamania.com${regular.properties.extendedImage?.publicId}`}
                        alt={regular.name}
                        className="size-60 m-auto mb-4"
                      />
                    ) : (
                      ""
                    )}
                    <p className="mb-4 px-6 text-sm text-center">{regular.d.txt}</p>
                  </div>
                  <div className="flex items-center justify-center bg-oaLightGray py-3 rounded-br-md rounded-bl-md">
                    <OACheckbox
                      checked={isSelected}
                      label={t("offer_selection.regulars_card.checkbox_label")}
                      className="text-oaRed"
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="m-4">
            <OAButton className="w-full h-12 text-xl" onClick={() => history.push("/user")}>
              {t("offer_selection.regulars_card.next")}
            </OAButton>
          </div>
        </main>
        <footer className="w-full md:hidden lg:block">
          <Footer></Footer>
        </footer>
      </>
    );

  if (step === "SELECT_PLAN")
    return (
      <>
        <main className="w-full bg-oaBackgroundColor bg-[url('/src/assets/picto.svg')] bg-no-repeat bg-contain bg-center bg-fixed md:bg-none flex  flex-col items-center md:px-20">
          <div className="w-full mt-10 md:mt-0">
            <Breadcrumbs />
          </div>

          <Link
            to="/clubs"
            className="absolute left-4 top-5 md:left-20 flex flex-row hover:text-oaRed transition-all duration-300"
          >
            <ChevronLeft className="mr-2" />
            {t("previous_step")}
          </Link>

          <section className="hidden lg:flex" style={{ alignSelf: "flex-start", flexDirection: "column" }}>
            <h2 className="text-xl">{t("offer_selection.current_club.title")}</h2>

            <Link to="/" className="text-base underline cursor-pointer hover:text-oaRed transition-all duration-300">
              {t("offer_selection.current_club.edit_club")}
            </Link>

            <article className="flex flex-col lg:flex-row gap-2 mt-4">
              <div className="w-24 h-24">
                {tunnel.club.imgUrl && (
                  <img className="w-24 h-24 object-cover" src={tunnel.club.imgUrl} alt={tunnel.club.name} />
                )}
              </div>
              <section className="flex flex-col">
                <h3 className="text-base font-bold">{tunnel.club.name}</h3>
                <address className="w-full text-sm not-italic flex items-center gap-1">
                  <div>{tunnel.club.address}</div>
                </address>
                <address className="w-full text-sm not-italic flex items-center gap-1">
                  <div>{tunnel.club.city}</div>
                </address>
              </section>
            </article>
          </section>

          <section className="p-4 bg-[#ebebeb] m-4 lg:hidden" style={{ alignSelf: "center", flexDirection: "column" }}>
            <div className="flex">
              <h2 className="text-xl mr-2">{t("offer_selection.current_club.title")}</h2>

              <Link to="/" className="text-base underline cursor-pointer hover:text-oaRed transition-all duration-300">
                {t("offer_selection.current_club.edit_club")}
              </Link>
            </div>

            <article className="flex flex-col lg:flex-row gap-2 mt-1">
              {/* <div className="w-24 h-24">
						{tunnel.club.imgUrl && <img className="w-24 h-24 object-cover" src={tunnel.club.imgUrl} alt={tunnel.club.name} />}
					</div> */}
              <section className="flex">
                <h3 className="text-base font-bold mr-2">{tunnel.club.name}</h3>
                <address className="w-full text-sm not-italic flex items-center gap-1">
                  <div>{tunnel.club.address}</div>
                </address>
              </section>
            </article>
          </section>

          <h2 className="text-[40px] font-bold text-center"> {t("offer_selection.title")} </h2>
          <PromoBanner club={tunnel.club} />

          {!tunnel.club?.offer_url && config.offer_expiration_date && (
            <div className="countDownContainer mt-10 flex flex-col items-center">
              <p className="text-oaRed font-bold text-center mb-4">
                {t("user_information.countdown.disclaimer").toUpperCase()}
              </p>
              <Countdown targetDate={config.offer_expiration_date} />
            </div>
          )}

          {splitPlans && (
            <div
              style={{ display: "flex", gap: "1rem", paddingTop: "1rem", paddingLeft: "1rem", paddingRight: "1rem" }}
            >
              <OAButton
                className={"h-16 text-lg lg:h-16 lg:text-2xl font-normal"}
                variant={split === "no_engagement" ? "fill" : "outline"}
                onClick={(e) => splitSet("no_engagement")}
              >
                Sans Engagement
              </OAButton>
              <OAButton
                className={"h-16 text-lg lg:h-16 lg:text-2xl font-normal"}
                variant={split === "comptant" ? "fill" : "outline"}
                onClick={(e) => splitSet("comptant")}
              >
                Paiement comptant
              </OAButton>
              <OAButton
                className={"h-16 text-lg lg:h-16 lg:text-2xl font-normal"}
                variant={split === "engagement" ? "fill" : "outline"}
                onClick={(e) => splitSet("engagement")}
              >
                Avec Engagement
              </OAButton>
            </div>
          )}

          {/* <ul className="w-full my-10 p-5 md:p-0 flex flex-col md:flex-row md:flex-wrap md:justify-center gap-8 animate-fade-in-down"> */}
          {!isMobile && (
            <ul className="w-full flex justify-between animate-fade-in-down max-w-[1200px] my-10 p-5 md:p-0">
              {filtered.map((plan, i) => (
                <li key={`plan_${i}`} className="w-[32%]">
                  <Choice value={plan} selected={[tunnel.offer].filter((e) => e)} onSelect={select} />
                </li>
              ))}
            </ul>
          )}

          {isMobile && (
            <div className="w-full p-5 md:p-0">
              <MobileCarousel plans={filtered}>
                {filtered.map((plan, i) => (
                  <Choice key={`plan_${i}`} value={plan} selected={[tunnel.offer].filter((e) => e)} onSelect={select} />
                ))}
              </MobileCarousel>
            </div>
          )}

          <div className="flex flex-col md:w-full md:flex-row items-start md:justify-center mt-20 mb-5 lg:mb-20 xl:mb-20">
            {code !== "onair.ma" && (
              <div className="flex flex-row md:flex-col md:w-[96px] md:mb-0 items-center">
                <div className="w-[60px] h-[60px] md:w-24 md:h-24 bg-white flex items-center justify-center border border-oaBorderColor rounded-[8px] md:mb-4 relative z-10">
                  <img
                    src="/oa-link.svg"
                    alt={t("offer_selection.subscription_title")}
                    className="size-12 object-contain"
                  />
                </div>
                <div className="ml-10 md:ml-0 w-60 md:w-44 xl:w-56">
                  <h3 className="2xl:text-xl md:text-center font-extrabold lg:mb-6">
                    {t("offer_selection.subscription_title")}
                  </h3>
                  <p className="text-black text-sm lg:text-xl font-medium md:text-center">
                    {t("offer_selection.subscription_description")}
                  </p>
                </div>
              </div>
            )}

            {code !== "onair.ma" && (
              <div className="bg-oaBorderColor w-px md:w-[15%] h-[5vh] md:h-px ml-8 -my-2 md:ml-0 md:mt-10"></div>
            )}

            <div className="flex flex-row md:flex-col md:w-[96px] md:mb-0 items-center">
              <div className="w-[60px] h-[60px] md:w-24 md:h-24 bg-white flex items-center justify-center border border-oaBorderColor rounded-[8px] md:mb-4 relative z-10">
                <img
                  src="/oa-couple.svg"
                  alt={t("offer_selection.card_sharing_title")}
                  className="size-12 object-contain"
                />
              </div>
              <div className="ml-10 md:ml-0 w-60 md:w-44 xl:w-56">
                <h3 className="2xl:text-xl md:text-center font-extrabold lg:mb-6">
                  {t("offer_selection.card_sharing_title")}
                </h3>
                <p className="text-black text-sm lg:text-xl font-medium md:text-center">
                  {t("offer_selection.card_sharing_description")}
                </p>
              </div>
            </div>

            <div className="bg-oaBorderColor w-px md:w-[15%] h-[5vh] md:h-px ml-8 -my-4 md:ml-0 md:mt-10"></div>

            <div className="flex flex-row md:flex-col md:w-[96px] md:mb-0 items-center">
              <div className="w-[60px] h-[60px] md:w-24 md:h-24 bg-white flex items-center justify-center border border-oaBorderColor rounded-[8px] md:mb-4 relative z-10">
                <img
                  src="/free-network.svg"
                  alt={t("offer_selection.network_access_title")}
                  className="size-12 object-contain"
                />
              </div>
              <div className="ml-10 md:ml-0 w-60 md:w-44 xl:w-56">
                <h3 className="2xl:text-xl md:text-center font-extrabold lg:mb-6">
                  {t("offer_selection.network_access_title")}
                </h3>
                <p className="text-black text-sm lg:text-xl font-medium md:text-center">
                  {t("offer_selection.network_access_description")}
                </p>
              </div>
            </div>

            <div className="bg-oaBorderColor w-px md:w-[15%] h-[5vh] md:h-px ml-8 -my-4 md:ml-0 md:mt-10"></div>

            <div className="flex flex-row md:flex-col md:w-[96px] md:mb-0 items-center">
              <div className="w-[60px] h-[60px] md:w-24 md:h-24 bg-white flex items-center justify-center border border-oaBorderColor rounded-[8px] md:mb-4 relative z-10">
                <img
                  src="/oa-showers.svg"
                  alt={t("offer_selection.showers_title")}
                  className="size-12 object-contain"
                />
              </div>
              <div className="ml-10 md:ml-0 w-60 md:w-44 xl:w-64">
                <h3 className="2xl:text-xl md:text-center font-extrabold lg:mb-6">
                  {t("offer_selection.showers_title")}
                </h3>
                <p className="text-black text-sm lg:text-xl font-medium md:text-center">
                  {t("offer_selection.showers_description")}
                </p>
              </div>
            </div>

            <div className="bg-oaBorderColor w-px md:w-[15%] h-[5vh] md:h-px ml-8 -my-4 md:ml-0 md:mt-10"></div>

            <div className="flex flex-row md:flex-col md:w-[96px] md:mb-0 items-center">
              <div className="w-[60px] h-[60px] md:w-24 md:h-24 bg-white flex items-center justify-center border border-oaBorderColor rounded-[8px] md:mb-4 relative z-10">
                <img src="/oa-phone.svg" alt={t("offer_selection.app_title")} className="size-12 object-contain" />
              </div>
              <div className="ml-10 md:ml-0 w-60 md:w-44 xl:w-56">
                <h3 className="2xl:text-xl md:text-center font-extrabold lg:mb-6">{t("offer_selection.app_title")}</h3>
                <p className="text-black text-sm lg:text-xl font-medium md:text-center">
                  {t("offer_selection.app_description")}
                </p>
              </div>
            </div>
          </div>

          <div className="text-black text-start pl-4 md:pl-10 mb-20 w-full">{t("offer_selection.footer_note")}</div>
        </main>
        <footer className="w-full md:hidden lg:block">
          <Footer></Footer>
        </footer>
      </>
    );
}
